module.exports = __webpack_public_path__ + "img/colab.b44381be.png";